<template>
  <div :class="_class">
    <div
      :class="_headclass"
      @click="headerClick"
    >
      <ten-icon
        icon="right"
        :class="_headIconClass"
      />
      <slot name="title">
        {{ title }}
      </slot>
    </div>
    <ten-slide-down>
      <div
        :class="_contentClass"
        v-show="_active"
      >
        <div :class="_contentItemClass">
          <slot />
        </div>
      </div>
    </ten-slide-down>
  </div>
</template>

<script>
import TenIcon from '../icon';
import TenSlideDown from '../scripts/components/slide-down';

const name = 'ten-collapse-item';
export default {
  name,
  components: {
    TenIcon,
    TenSlideDown,
  },
  props: {
    /**
     * 唯一标志符
     */
    index: String,
    /**
     * 面板项标题
     */
    title: [String, Number],
    /**
     * 是否禁用
     */
    disabled: Boolean,
  },
  inject: ['collapse'],
  computed: {
    _active() {
      return this.collapse._active.indexOf(this.index) > -1;
    },
    _class() {
      return [
        `${name}`,
        {
          [`${name}--active`]: this._active,
        },
      ];
    },
    _headclass() {
      return [
        `${name}__head`,
      ];
    },
    _headIconClass() {
      return [
        `${name}__head-icon`,
      ];
    },
    _contentItemClass() {
      return [
        `${name}__content-item`,
      ];
    },
    _contentClass() {
      return [
        `${name}__content`,
      ];
    },
  },
  methods: {
    headerClick() {
      if (this.disabled) return;
      this.collapse.$emit('collapse.click', this.index);
    },
  },
};
</script>
